import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { useGetClientDebt } from 'api/clients/use-get-client-debt.ts';
import { round100 } from 'shared/utils/numbers/round.ts';
import styles from './credit-limit-alert.module.scss';
import type { ICreditLimitAlertProps } from './types.ts';

export const CreditLimitAlert: React.FC<ICreditLimitAlertProps> = (props) => {
  const { clientId, creditLimit } = props;
  const { t } = useTranslation();
  const { data: debt } = useGetClientDebt(clientId);

  const hasCreditLimit = creditLimit !== null && creditLimit !== undefined;
  const isExceeded = hasCreditLimit && debt && round100(creditLimit - debt.totalDebt) < 0;

  if (!isExceeded) return null;

  return (
    <Alert
      className={styles.alert}
      icon={<WarningOutlined />}
      message={<strong className={styles.text}>{t('client:credit_limit_exceeded')}</strong>}
      type='warning'
      showIcon
    />
  );
};
